import { createTheme } from '@mui/material/styles';

/** サイト共通フォント（Noto Sans JP は public/index.html で読み込み） */
export const FONT_FAMILY = [
  '"Noto Sans JP"',
  '"Hiragino Kaku Gothic ProN"',
  '"Hiragino Sans"',
  'Meiryo',
  'sans-serif',
].join(',');

/** サイト共通テーマ */
export const theme = createTheme({
  typography: {
    fontFamily: FONT_FAMILY,
  },
});
